// Data-only contracts shared by the server projection publisher and browser.
/** Every screen with a projection. `tasks` (2026-10-08): every open task in every
 * list, the five Tasks pages filter it in the browser. */
export const SYNC_SURFACES = ["accounts", "sales", "account", "planning", "tasks"] as const
export type SyncSurface = (typeof SYNC_SURFACES)[number]
export type SyncRow = { key: string; payload: unknown }
export type SyncManifest = {
  surface: SyncSurface
  scope: string
  viewer: string
  companyId?: string
  revision: string
  builtAt: string
}
export type SyncSnapshot = { manifest: SyncManifest; rows: SyncRow[] }
export type SyncStatus = "connecting" | "live" | "updating" | "paused" | "denied"
export const SYNC_SCHEMA = "1"
export const syncCookie = (surface: SyncSurface) => `os-sync-${surface}`

export function rowPayload(value: unknown): unknown {
  // JSONB travels as a Postgres text value in Electric's HTTP protocol.
  return typeof value === "string" ? JSON.parse(value) : value
}
